import { compose } from "redux";
import { Grid } from "@material-ui/core";
import { Field } from "redux-form/immutable";
import React, { PureComponent } from "react";

import { BasePageTitle } from "altus-ui-components";

import TextField from "app/components/form/TextField";
import { SUB_CONTRACTOR_FORM } from "features/planner/planner.constants";

class SubContractorDepartureForm extends PureComponent {
  render() {
    return (
      <Grid
        item
        xs={6}
        lg={2}
        container
        direction="column"
        style={{
          display: "block",
        }}
      >
        <Grid item>
          <BasePageTitle title="Departure" />
        </Grid>
        <Grid item xs>
          <Field
            label="DaWinci"
            component={TextField}
            name={SUB_CONTRACTOR_FORM.TRAVEL_DA_WINCI}
          />
        </Grid>
        <Grid item xs>
          <Field
            label="Vantage"
            component={TextField}
            name={SUB_CONTRACTOR_FORM.TRAVEL_VANTAGE}
          />
        </Grid>
        <Grid item xs>
          <Field
            label="Ticket"
            component={TextField}
            name={SUB_CONTRACTOR_FORM.TRAVEL_TICKET}
          />
        </Grid>
        <Grid item xs>
          <Field
            label="Airport"
            component={TextField}
            name={SUB_CONTRACTOR_FORM.TRAVEL_AIRPORT}
          />
        </Grid>
      </Grid>
    );
  }
}

export default compose()(SubContractorDepartureForm);
